export abstract class BaseComponent<O = any, S = any> {
  public element: HTMLElement;
  public options: O;
  public state: S;
  protected eventListeners: { element: HTMLElement | Window | Document, type: string, handler: EventListener }[] = [];

  constructor(element: HTMLElement, options: Partial<O> = {}) {
    this.element = element;
    this.options = { ...this.getDefaultOptions(), ...options } as O;
    this.state = {} as S;
    
    this.init();
  }
  
  protected getDefaultOptions(): O {
    return {} as O;
  }
  
  protected init(): void {
    this.bindEvents();
    this.setupObservers();
    this.render();
  }
  
  protected bindEvents(): void {
    // Override in subclasses
  }
  
  protected setupObservers(): void {
    // Override in subclasses
  }
  
  protected render(): void {
    // Override in subclasses
  }

  protected addEvent(element: HTMLElement | Window | Document, type: string, handler: EventListener): void {
    element.addEventListener(type, handler);
    this.eventListeners.push({ element, type, handler });
  }

  public emit(event: string, detail: any = {}): void {
    const customEvent = new CustomEvent(`fz:${event}`, {
      detail,
      bubbles: true,
      cancelable: true
    });
    this.element.dispatchEvent(customEvent);
  }

  public destroy(): void {
    this.eventListeners.forEach(({ element, type, handler }) => {
      element.removeEventListener(type, handler);
    });
    this.eventListeners = [];
  }
}
